import { render, staticRenderFns } from "./BindingFollow_up.vue?vue&type=template&id=70c016f2&scoped=true"
import script from "./BindingFollow_up.vue?vue&type=script&lang=js"
export * from "./BindingFollow_up.vue?vue&type=script&lang=js"
import style0 from "./BindingFollow_up.vue?vue&type=style&index=0&id=70c016f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c016f2",
  null
  
)

export default component.exports